import { App, Flex } from "antd";
import { FC } from "react";
import {
    deleteSchedulerRemovePointsFromSchedule,
    getApiError,
} from "tm-shared/api";

import { useAsyncAction } from "@/hooks";
import { useAppDispatch } from "@/hooks/redux";
import {
    RouteEditorModal,
    RouteEditorModalPayloads,
} from "@/pages/SV/RouteManagement/RouteEditor/RouteEditor.types";
import { BaseModal } from "@/shared/ui/BaseModal";
import { PrimaryText } from "@/shared/ui/Typography";
import { deleteSchedules } from "@/store/slices/manager";

interface DeleteScheduleModalProps {
    onClose: () => void;
    payload: RouteEditorModalPayloads[RouteEditorModal.DeleteSchedule];
    onApprove: () => Promise<void>;
}

export const DeleteScheduleModal: FC<DeleteScheduleModalProps> = ({
    onClose,
    payload,
    onApprove,
}) => {
    const { notification } = App.useApp();

    const dispatch = useAppDispatch();

    const { pointIds, createMode, isEmptyAfterDelete } = payload;

    const multiSelectMode = pointIds.length > 1;

    const [handleDelete, deleteLoading] = useAsyncAction(async () => {
        if (createMode) {
            dispatch(deleteSchedules(pointIds));
            onClose();
            await onApprove();

            return;
        }

        const { currentRouteId } = payload as Extract<
            typeof payload,
            { createMode: false }
        >;

        try {
            await deleteSchedulerRemovePointsFromSchedule({
                pointIds,
                routeId: currentRouteId,
            });

            await onApprove();

            onClose();
        } catch (err) {
            console.log(err);

            const { displayMessage } = getApiError(err);
            notification.error({
                title: "Не вдалося видалити торгову точку",
                description: displayMessage,
            });
        }
    });

    const getDeleteWarningText = () => {
        if (multiSelectMode && isEmptyAfterDelete) {
            return "Ви дійсно хочете видалити вибрані торгові точки з цього маршруту? Після підтвердження маршрут буде порожнім";
        }
        if (multiSelectMode) {
            return "Ви дійсно хочете видалити вибрані торгові точки з цього маршруту?";
        }
        return "Ви дійсно хочете видалити обрану торгову точку з цього маршруту?";
    };

    return (
        <BaseModal
            open
            onClose={onClose}
            confirmText="Видалити"
            confirmLoading={deleteLoading}
            onConfirm={handleDelete}
            mask={{ closable: !deleteLoading }}
        >
            <Flex vertical gap={16}>
                <PrimaryText
                    fontSize={20}
                    fontWeight="500"
                    style={{ textAlign: "center" }}
                >
                    Видалити ТТ
                </PrimaryText>

                <PrimaryText>{getDeleteWarningText()}</PrimaryText>
            </Flex>
        </BaseModal>
    );
};
